import { Component, OnInit } from '@angular/core';
import { MATERIAL_IMPORTS } from '../../shared/material/material';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import Swal from 'sweetalert2';
import { messages } from '../../shared/messages/messages';
import { MatDialog } from '@angular/material/dialog';
import { SolicitarAcceso } from './solicitar-acceso/solicitar-acceso';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-login',
  imports: [...MATERIAL_IMPORTS, ReactiveFormsModule],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login implements OnInit {
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}
  // ------------------------------------------------------
  // ------------- Olvide mi contraseña--------------------
  // ------------------------------------------------------
  // async goToForgotPassword() {
  //   const { value: email } = await Swal.fire({
  //     title: 'Recuperar contraseña',
  //     html: `
  //     <p>
  //       Ingresa el correo electrónico asociado a tu cuenta.
  //     </p>
  //   `,
  //     input: 'email',
  //     inputPlaceholder: 'correo@ejemplo.com',

  //     confirmButtonText: 'Enviar',
  //     cancelButtonText: 'Cancelar',

  //     showCancelButton: true,

  //     confirmButtonColor: '#6FB6A6',
  //     cancelButtonColor: '#B9B9BC',

  //     inputValidator: (value) => {
  //       if (!value) {
  //         return 'Debes ingresar un correo electrónico.';
  //       }

  //       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  //       if (!emailRegex.test(value)) {
  //         return 'Ingresa un correo válido.';
  //       }

  //       return null;
  //     },
  //   });

  //   if (!email) {
  //     return;
  //   }

  //   // Simulación del envío
  //   messages.messageSaving('Enviando', 'Estamos enviando el correo de recuperación...');

  //   setTimeout(() => {
  //     Swal.close();

  //     messages.succesMessageGraph(
  //       `Si el correo <b>${email}</b> está registrado, recibirás un enlace para restablecer tu contraseña.`,
  //     );
  //   }, 1500);
  // }

  goToForgotPassword(): void {
    this.router.navigate(['/recuperar-password']);
  }

  // ------------------------------------------------------
  // ------------------------------------------------------

  loginForm!: FormGroup;

  // ------------------------------------------------------
  // ------------- Recordarme correo--------------------
  // ------------------------------------------------------
  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      rememberMe: [false],
    });

    const savedEmail = localStorage.getItem('rememberedEmail');

    if (savedEmail) {
      this.loginForm.patchValue({
        email: savedEmail,
        rememberMe: true,
      });
    }

    // =====================================================
    // MOSTRAR MENSAJE SI VIENE DE UN LOGOUT FORZADO
    // =====================================================

    const authReason = this.route.snapshot.queryParams['authReason'];

    if (authReason) {
      this.mostrarMensajeAuth(authReason);

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {},
        replaceUrl: true,
      });
    }
  }

  private mostrarMensajeAuth(reason: string): void {
    const mensajes: Record<string, { title: string; text: string; icon: 'info' | 'warning' }> = {
      expired: {
        title: 'Sesión expirada',
        text: 'Tu sesión ha caducado, por favor inicia sesión nuevamente.',
        icon: 'info',
      },

      'no-session': {
        title: 'Inicia sesión',
        text: 'Debes iniciar sesión para acceder a esta sección.',
        icon: 'warning',
      },
    };

    const config = mensajes[reason];

    if (!config) {
      return;
    }

    Swal.fire({
      icon: config.icon,
      title: config.title,
      text: config.text,
      showConfirmButton: false,
      timer: 2000,
      customClass: {
        title: 'mi-swal-title',
        htmlContainer: 'mi-swal-text',
      },
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  showPassword = false;
  password = '';

  async onLogin() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const { email, password, rememberMe } = this.loginForm.value;

    if (rememberMe) {
      localStorage.setItem('rememberedEmail', email);
    } else {
      localStorage.removeItem('rememberedEmail');
    }

    try {
      const respuesta = await firstValueFrom(
        this.authService.login({
          email,
          password,
        }),
      );

      // console.log(respuesta);
      localStorage.setItem('token', respuesta.accessToken);
      this.authService.actualizarUsuarioCompleto(respuesta.user);

      await Swal.fire({
        icon: 'success',
        title: 'Inicio de sesión exitosa',
        showConfirmButton: false,
        timer: 1000,
        customClass: {
          title: 'mi-swal-title',
          htmlContainer: 'mi-swal-text',
        },
      });

      this.router.navigate(['/inicio']);
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Inicio de sesión fallida',
        text: error['error']?.message ?? 'Credenciales incorrectas',
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          title: 'mi-swal-title',
          htmlContainer: 'mi-swal-text',
        },
      });
      // console.log(error['error']?.message);
    }
    // console.log('siguiente');
  }

  solicitarAcceso() {
    this.dialog.open(SolicitarAcceso, { maxWidth: '90vw', maxHeight: '90vh' });
  }
}
